import { useCallback, useEffect, useState } from 'react';
/**
 * A hook used to handle infinite scrolling/pagination in a dropdown
 */
export default (_ref => {
  let {
    items,
    hasNextPage,
    fetchNextPage,
    setItems,
    lastItem
  } = _ref;
  const [isFetchingNextPage, setIsFetchingNextPage] = useState(false);
  const fetch = useCallback(async () => {
    setIsFetchingNextPage(true);
    const newItems = await fetchNextPage();
    setItems(currentItems => [...currentItems, ...newItems]);
    setIsFetchingNextPage(false);
  }, [fetchNextPage, setItems]);
  useEffect(() => {
    if (!lastItem) {
      return;
    }
    if (lastItem.index >= items.length - 1 && hasNextPage && !isFetchingNextPage) {
      fetch();
    }
  }, [hasNextPage, fetchNextPage, items.length, lastItem, isFetchingNextPage, fetch]);
});
//# sourceMappingURL=useInfiniteScroll.js.map